import type { EmptyProps } from '@c/empty'
import type { SpinProps } from 'antd'
import type { PropsWithChildren, ReactNode } from 'react'
import Empty from '@c/empty'
import { Skeleton, Spin } from 'antd'

export interface LoadingBoxProps extends PropsWithChildren<CommonProps>, Partial<Pick<SpinProps, 'indicator'>> {
  /**
   * 是否加载中
   * @default false
   */
  loading?: boolean
  /**
   * 加载中类型
   * - list：列表骨架
   * - wrap：包裹
   * - default：默认加载中
   * @default default
   */
  type?: 'list' | 'wrap' | 'default'
  /**
   * 空状态 props
   */
  emptyProps?: Omit<EmptyProps, 'children'>
}

const LoadingBox = ({
  loading = false,
  type = 'default',
  indicator,
  children,
  className,
  style,
  emptyProps,
}: LoadingBoxProps) => {
  const typeMap: Record<string, ReactNode> = {
    list: (
      <>
        <Skeleton active paragraph={{ rows: 2 }} />
        <div className="my-5 b-b-1 b-solid b-default" />
        <Skeleton active paragraph={{ rows: 2 }} />
      </>
    ),
    default: (
      <div className="absolute inset-0 fccc">
        <Spin indicator={indicator} />
      </div>
    ),
  }
  if (type === 'wrap') {
    return (
      <Spin className="block h-full w-full" indicator={indicator} spinning={loading}>
        <Empty
          showEmpty={isDef(loading) && isDef(emptyProps?.data)}
          {...emptyProps}
          className={className}
          style={style}
        >
          {children}
        </Empty>
      </Spin>
    )
  }

  return (
    <div className={clsx('relative h-full w-full', className)} style={style}>
      {loading ? (
        typeMap[type]
      ) : (
        <Empty showEmpty={isDef(loading) && isDef(emptyProps?.data)} {...emptyProps}>
          {children}
        </Empty>
      )}
    </div>
  )
}
export default LoadingBox
